
export default function ProjectPts ({ projectPoints }) {
  return (
    <section>
      {
        projectPoints
          ? (
            <ul className='max-w-max h-max'>
              {
                projectPoints.map((point) => {
                  return (
                    <li class='text-base text-left text-white bg-black opacity-90 px-[10px] py-[5px]'>
                      {point}
                    </li>
                  )
                })
              }
            </ul>
            )
          : null
      }
    </section>
  )
}
